import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserStateService } from '../user-state/user-state.service';
import { first, of, tap } from 'rxjs';
import { UserDataResponse } from '@app/utils/interfaces/user-data';

export const userRoleResolver: ResolveFn<UserDataResponse | null> = () => {
  const userState = inject(UserStateService);
  const currentUser = userState.userData();

  if (currentUser) {
    return of(currentUser);
  }
  
  return userState.getCurrentUserData().pipe(
    tap((response) => {
      if (response) {
        userState.userData.set(response);
        userState.updateUserState().pipe(first()).subscribe();
      }
    }),
    first()
  );
};